module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS13.3f065d5e.jpg";